const NoConnectIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Capa_1"
    x={0}
    y={0}
    style={{
      enableBackground: 'new 0 0 100 100',
    }}
    viewBox="0 0 100 100"
    {...props}
  >
    <style>{'.st0{fill:#fa3c57}'}</style>
    <g id="bold">
      <path
        d="M50 99C22.98 99 1 77.02 1 50S22.98 1 50 1s49 21.98 49 49-21.98 49-49 49zm0-89.84C27.48 9.16 9.16 27.48 9.16 50S27.48 90.84 50 90.84 90.84 72.52 90.84 50 72.52 9.16 50 9.16z"
        className="st0"
      />
      <path
        d="M18.25 85.84c-1.05 0-2.09-.4-2.88-1.19a4.098 4.098 0 0 1 0-5.78l63.51-63.51a4.098 4.098 0 0 1 5.78 0 4.098 4.098 0 0 1 0 5.78l-63.53 63.5c-.79.8-1.84 1.2-2.88 1.2zM54.79 56.76 41.52 70.02C43.2 73 46.36 75.04 50 75.04c5.39 0 9.78-4.4 9.78-9.8 0-3.65-2.03-6.79-4.99-8.48zM32.78 55.55c.43-.43.88-.82 1.34-1.22l14.04-14.04c-7.99.45-15.45 3.75-21.17 9.49a4.09 4.09 0 0 0 .02 5.78c1.6 1.59 4.19 1.59 5.77-.01zM66.68 44.87l-6.01 6.01a24.6 24.6 0 0 1 6.54 4.68 4.092 4.092 0 0 0 5.78.01c1.6-1.59 1.6-4.18.02-5.78a32.648 32.648 0 0 0-6.33-4.92zM77.67 33.89l-5.84 5.84c2.18 1.46 4.23 3.14 6.12 5.04a4.092 4.092 0 0 0 5.78.01c1.6-1.59 1.6-4.18.02-5.78-1.9-1.9-3.95-3.58-6.08-5.11zM22.05 44.76c7.47-7.51 17.4-11.64 27.95-11.64 1.68 0 3.34.14 4.98.35l6.95-6.95c-3.86-1-7.85-1.56-11.93-1.56-12.74 0-24.72 4.99-33.74 14.04a4.09 4.09 0 0 0 .02 5.78c1.59 1.59 4.18 1.58 5.77-.02z"
        className="st0"
      />
    </g>
  </svg>
);
export default NoConnectIcon;
